<template>
  <v-form
    ref="form"
    @submit.prevent="submit"
    @keypress.13.stop
  >
    <TextField
      v-model="search"
      v-on="$listeners"
      :class="$style.search"
      :dense="dense"
      blue_icon
      :label="label"
      :background-color="background_color"
      :loading="loading"
      prepend-inner-icon="mdi-magnify"
      :hide-details="hide_details"
      clearable
      @keyup.esc="clear_search"
      @click:clear="clear_search"
      @click:prepend-inner="submit"
      @input="update_search"
      @on_paste="on_paste"
      inputmode="search"
      enterkeyhint="search"
      type="search"
      :rules="rules"
      :disabled="disabled"
    />
  </v-form>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { TextField } from '../global/inputs/text-field';

@Component({
  components: {
    TextField,
  },
})
export default class Search extends Vue {
  @Prop({ type: Boolean, default: undefined })
  disabled!: boolean | undefined

  @Prop({ type: String, default: 'Поиск' })
  label!: string;

  @Prop({ type: String, default: '#fff' })
  background_color!: string;

  @Prop({ type: Boolean, default: false })
  dense!: boolean;

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  @Prop({ type: Boolean, default: true })
  hide_details!: boolean;

  @Prop({ type: String, default: '', required: false })
  passed_search!: string;

  @Prop({ type: Array, default: () => ([]) })
  rules!: [];

  @Watch('passed_search')
  on_set_search_change() {
    this.search = this.passed_search;
  }

  searchVal = this.passed_search;

  get search() {
    return this.searchVal;
  }

  set search(val: string) {
    this.searchVal = val;
  }

  is_valid_search(val: string) {
    return val ? val.trim().length > 0 : false;
  }

  clear_text() {
    this.search = '';
  }

  clear_search() {
    this.search = '';
    this.$emit('clear', '');
  }

  update_search(new_search: string | null) {
    if (new_search !== null) {
      this.search = new_search.replace(/\s+/g, ' ');
    } else {
      this.search = '';
    }
  }

  on_paste(event: ClipboardEvent) {
    if (event.clipboardData) {
      event.preventDefault();

      const text = event.clipboardData.getData('text/plain');

      this.update_search(text);
    }
  }

  submit() {
    if (this.is_valid_search(this.search)) {
      this.$emit('submit', this.search.trim());
    }
  }
}
</script>

<style module lang="scss">
.search {
  max-width: 100%;
}

@media (min-width: 600px) and (max-width: 959px) {
  .search {
    max-width: 100%;
  }
}

@media (max-width: 599px) {
  .search {
    max-width: 100%;
  }
}
</style>
